import { Box, BoxProps as IBoxProps, styled } from "@mui/material";

export const HtmlViewWrapper = styled(
  Box,
  {},
)<Partial<IBoxProps>>(({ theme }) => ({
  "&.html-container": {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    [theme.breakpoints.down("sm")]: {
      padding: "10px",
    },
    ".loader": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "90vh",
      [theme.breakpoints.between("xs", "sm")]: {
        height: "70vh",
      },
    },
    ".iframe": {
      width: "100%",
      border: "none",
      marginTop: "1rem",
      paddingRight: "2rem",
      [theme.breakpoints.down("sm")]: {
        paddingRight: "0",
      },
    },
  },
}));
